import {SunOutlined, MoonOutlined} from '@ant-design/icons' 
import { useContext, useState } from 'react'
import { AppState } from '../App'
import Marquee from "react-fast-marquee";
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import BnbRain from './BnbRain'
import Register from './Register';

const Homepage = () => {
  const navigate = useNavigate();
  const useAppState = useContext(AppState);
  const [id, setId] = useState("");
  const [load, setLoad] = useState(false);
  const [show, setShow] = useState(false);

  const CorrectSvg = () => (
    <svg
      className="flex-shrink-0 w-5 h-5 text-purple-500 dark:text-purple-400"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        clip-rule="evenodd"
      ></path>
    </svg>
  );

  async function getData() {
    setLoad(true);
    if(Number(id) < Number(useAppState.id) || Number(useAppState.id) == 0) {
      message.error("Invalid Downline ID")
      return
    }

    let _id = await useAppState.staticContract.userInfo(id);
    if(_id.referrer == "0x0000000000000000000000000000000000000000") {
      message.error("Invalid Id");
      return;
    } 

    useAppState.setWalletAddress(_id.account);
    useAppState.setId(id);
    navigate('/dashboard');
    setLoad(false);
  }

  return (
    <div>
      <Modal
        open={show}
        footer={null}
        onCancel={() => setShow(false)}
        title="Preview"
      >
      <div className='border-1 w-full bg-gray-600 mt-2 mb-3'></div>
      <div className='flex w-full justify-center items-center'>
        <input onChange={(e) => setId(e.target.value)} value={id} className='bg-gray-200 outline-none text-gray-800 font-semibold p-3 w-2/3' placeholder='Enter Id' />
        <button onClick={getData} className='bg-purple-500 rounded-md text-white w-1/3 ml-3 p-3 font-semibold'>Preview</button>
      </div>

      </Modal>

      <Register />

      <header className="fixed w-full z-10 shadow-md bg-gradient-to-r from-gray-800 to-gray-900 text-white">
        <nav className="flex items-center justify-between max-w-6xl px-6 mx-auto py-4">
          <a href="#" className="flex items-center">
            <img src="logo.png" className="h-14" alt="RideBNB Logo" />
            <span className="ml-3 text-2xl font-bold tracking-wide flex flex-col items-start justify-center"><span>RAIN<span className="text-yellow-500">BNB</span></span><span className='text-sm font-semibold md:text-xl'>The Nex Gen of Ride<span className='text-yellow-500'>BNB</span></span></span>
          </a>
          {/* <a href="#" className="flex items-center">
            <img src="https://www.r2r.pro/logo.png" className="h-10" alt="RideBNB Logo" />
          </a> */}
          {/* <div className="hidden lg:flex items-center space-x-6"> */}
            {/* <a href="#features" className="hover:underline">Features</a>
            <a href="#tech" className="hover:underline">Tech</a>
            <a href="#roadmap" className="hover:underline">Roadmap</a> */}
          {/* </div> */}
          <button
            onClick={() => useAppState.Login()}
            className="bg-yellow-500 text-gray-900 hover:bg-yellow-600 font-semibold px-5 py-2 rounded-lg transition-all duration-300"
          >
            Login
          </button>
        </nav>
      </header>


      <section className="bg-gradient-to-b from-gray-900 to-black text-white py-20">
        <div className="grid max-w-6xl px-6 mx-auto lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7 py-8">
            {/* <p className="text-2xl text-teal-500 font-bold uppercase mb-4 tracking-wider opacity-80">
              The Next Generation of <span className='text-white'>RIDE <span className='text-yellow-500'>BNB</span></span>
            </p> */}
            <h1 className="text-4xl text-yellow-500 lg:text-5xl font-extrabold leading-tight mb-6">
            "Shaping Futures, <br /> Together"
            </h1>
            <p className="text-lg lg:text-xl mb-8 opacity-90">
              <b>RAIN BNB</b> represents the next generation of RideBNB, offering enhanced opportunities and greater potential for users. Building on the foundation of its predecessor, RAIN BNB leverages advanced Web 3.0 technologies, including blockchain and smart contracts, to create a more innovative and dynamic platform. With a focus on empowering individuals and fostering economic independence, RAIN BNB opens new pathways for personal and professional growth. Our upgraded platform amplifies community success, ensuring a future driven by collaboration, transparency, and cutting-edge innovation.
            </p>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => setShow(!show)}
                className="bg-white text-purple-600 hover:text-white hover:bg-purple-600 font-semibold px-6 py-3 rounded-lg shadow-lg transition-all duration-300"
              >
                Preview ID
              </button>

              <a
                href='https://drive.google.com/file/d/1Meo_DjTyNlKqsCrDA3pfM-4S_CDeVRBy/view?usp=sharing'
                target="_blank"
                className="ml-2 bg-yellow-500 text-black hover:text-gray-800 hover:bg-yellow-600 font-semibold px-6 py-3 rounded-lg shadow-lg transition-all duration-300"
              >
                Download APK
              </a>
            </div>
          </div>
          <div className="lg:col-span-5 flex justify-center">
            <img
              src="hero.png"
              alt="Hero Illustration"
              className="w-full max-w-md lg:max-w-full rounded-lg shadow-xl"
            />
          </div>
        </div>
      </section>

      <section className="bg-gradient-to-r from-blue-500 via-cyan-500 to-indigo-500 text-white py-20">
        <div className="grid max-w-6xl px-6 mx-auto lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <h1 className="text-4xl lg:text-5xl font-extrabold leading-tight mb-6">
            "Empowering Journeys, Transforming Lives"
            </h1>
            <p className="text-lg lg:text-xl mb-8 opacity-90">
              At RainBNB, our vision is to revolutionize the way people achieve economic freedom and mobility through the power of decentralization. By leveraging cutting-edge Web 3.0 technologies, we aim to create a transparent, inclusive, and secure platform that empowers individuals to unlock their full potential. We envision a world where innovation drives financial independence, opportunities are limitless, and success is accessible to everyone, everywhere.
            </p>
            {/* <button
              onClick={() => setShow(!show)}
              className="mt-6 bg-white text-blue-600 font-semibold px-8 py-3 rounded-lg hover:bg-gray-200 shadow-lg transition-all duration-300"
            >
              Preview ID
            </button>  */}
          </div>
          <div className="lg:col-span-5 flex justify-center">
            <img
              src="https://img.icons8.com/?size=100&id=mGY1eh5Njfj3&format=png&color=000000"
              alt="Explore RainBNB"
              className="h-80 rounded-lg shadow-xl"
            />
          </div>
        </div>
      </section>

<section className="py-16 bg-gray-50 text-gray-800">
  <div className="max-w-6xl mx-auto px-6">
    <h2 className="text-3xl font-bold text-center mb-10">Why Choose RainBNB?</h2>
    <div className="grid md:grid-cols-3 gap-8">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <img src="https://img.icons8.com/?size=100&id=vauY87Ql6pnA&format=png&color=000000" alt="Unique Stays" className="h-16 mx-auto mb-4" />
        <h3 className="text-xl font-semibold mb-2">Decentralized</h3>
        <p>RainBNB: A decentralized platform ensuring transparency, security, and empowering users with financial independence.</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <img src="https://img.icons8.com/?size=100&id=WpfQ7DvG8Z3W&format=png&color=000000" alt="Local Hosts" className="h-16 mx-auto mb-4" />
        <h3 className="text-xl font-semibold mb-2">Path to Financial Freedom</h3>
        <p>CRainBNB empowers users to achieve economic independence through decentralized opportunities and innovative solutions.</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        <img src="https://img.icons8.com/?size=100&id=XsvEZR0h6fav&format=png&color=000000" alt="Secure Booking" className="h-16 mx-auto mb-4" />
        <h3 className="text-xl font-semibold mb-2">Global Accessibility</h3>
        <p>With no centralized restrictions, RainBNB provides equal opportunities for users worldwide to thrive.</p>
      </div>
    </div>
  </div>
</section>

<section className="py-16 bg-gray-100 text-gray-800">
  <div className="max-w-6xl mx-auto px-6">
    <h2 className="text-3xl font-bold text-center mb-10">What Our Users Say</h2>
    <div className="grid md:grid-cols-3 gap-8">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <p className="italic mb-4">"RainBNB is truly a game-changer! With its innovative use of Web 3.0 technology, I finally see a clear path to achieving my financial freedom. The transparency and opportunities provided by this platform are unmatched, and I feel empowered to take control of my future like never before."</p>
        <h3 className="text-lg font-semibold">- Alex J.</h3>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <p className="italic mb-4">"RainBNB has completely transformed the way I view financial opportunities. I’m excited about the potential it offers to build a stable and independent financial future. It’s more than just a platform—it’s the key to unlocking endless possibilities for growth and success!"</p>
        <h3 className="text-lg font-semibold">- Maria G.</h3>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <p className="italic mb-4">"RainBNB is a breath of fresh air in the world of finance and technology. Its Web 3.0 foundation gives me the confidence to pursue my goals with transparency and security. This platform is opening doors I never thought possible, and I truly believe it’s my gateway to long-term financial freedom and success!"</p>
        <h3 className="text-lg font-semibold">- Daniel T.</h3>
      </div>
    </div>
  </div>
</section>

{/* <section className="bg-blue-50 py-16">
  <div className="max-w-6xl mx-auto px-6">
    <h2 className="text-3xl font-bold text-center text-blue-600 mb-10">Our Roadmap</h2>
    <div className="grid md:grid-cols-4 gap-8">
      <div className="text-center">
        <div className="bg-blue-100 rounded-full w-20 h-20 mx-auto flex items-center justify-center mb-4 text-xl font-bold">Q1</div>
        <h3 className="text-lg font-semibold mb-2">Launch Platform</h3>
        <p>Introduce RainBNB with exclusive features and unique stays.</p>
      </div>
      <div className="text-center">
        <div className="bg-blue-100 rounded-full w-20 h-20 mx-auto flex items-center justify-center mb-4 text-xl font-bold">Q2</div>
        <h3 className="text-lg font-semibold mb-2">Expand Offerings</h3>
        <p>Partner with more hosts globally to provide diverse accommodations.</p>
      </div>
      <div className="text-center">
        <div className="bg-blue-100 rounded-full w-20 h-20 mx-auto flex items-center justify-center mb-4 text-xl font-bold">Q3</div>
        <h3 className="text-lg font-semibold mb-2">Mobile App</h3>
        <p>Launch a dedicated app for seamless booking experiences.</p>
      </div>
      <div className="text-center">
        <div className="bg-blue-100 rounded-full w-20 h-20 mx-auto flex items-center justify-center mb-4 text-xl font-bold">Q4</div>
        <h3 className="text-lg font-semibold mb-2">Community Events</h3>
        <p>Host events to bring hosts and travelers together.</p>
      </div>
    </div>
  </div>
</section> */}

<section className="bg-gradient-to-r from-purple-500 to-indigo-500 py-16 text-white">
  <div className="max-w-6xl mx-auto px-6 text-center">
    <h2 className="text-4xl font-bold mb-6">Start Your Journey with RainBNB</h2>
    <p className="text-lg mb-10">Embark on memorable adventures while supporting local communities and enjoying exclusive stays worldwide.</p>
    {/* <button className="bg-white text-purple-600 font-semibold px-8 py-3 rounded-lg hover:bg-gray-200 shadow-lg transition-all duration-300">
      Get Started Now
    </button> */}
  </div>
</section>

<footer className="bg-gray-900 text-gray-300 py-10">
  <div className="max-w-6xl mx-auto text-center">
    <img src="logo192.png" className="h-8 mx-auto mb-3" alt="RainBNB Logo" />
    <p>© 2025 RainBNB. All Rights Reserved.</p>
    <p className="mt-2">Follow us on
      <a href="#" className="text-blue-500 ml-2">Twitter</a>,
      <a href="#" className="text-blue-500 ml-2">Instagram</a>, and
      <a href="#" className="text-blue-500 ml-2">Facebook</a>.
    </p>
  </div>
</footer>

    <BnbRain />

    </div>
  );
}

export default Homepage
